import { Component } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { featherChevronRight } from '@ng-icons/feather-icons';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { PlanUsageIndicatorComponent } from '../plan-usage-indicator/plan-usage-indicator.component';
import { SidemenuNavComponent } from './sidemenu-nav/sidemenu-nav.component';
import { BaseComponent } from 'src/app/components/_base/base.component';

@Component({
  templateUrl: './sidebar.component.html',
  styles: [
    `
      .router-link-active {
        @apply before:absolute before:left-0 before:top-0 before:h-full before:w-1 before:rounded-r before:bg-[#1E2028] before:py-2 before:content-[''];
      }
    `,
  ],
  standalone: true,
  selector: 'app-sidebar',
  imports: [SidemenuNavComponent, UserMenuComponent, PlanUsageIndicatorComponent],
  viewProviders: [
    provideIcons({
      featherChevronRight,
    }),
  ],
})
export class SidebarComponent extends BaseComponent {
  selectedMenuItem: number | null = null;
  selectedSubmenuItem: number | null = null;

  onSelectSubMenuItem(index: number | null): void {
    this.selectedSubmenuItem = this.selectedSubmenuItem === index ? null : index;
  }
  onSelectMenuItem(index: number | null) {
    if (this.selectedMenuItem !== index) this.onSelectSubMenuItem(null);

    this.selectedMenuItem = index;
  }
}
